import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { harmonateDataGridSx } from '../../../theme/harmonateStyles';
import { harmonateTokens as ht } from '../../../theme/harmonateTokens';

const UserDrawer = ({ tenantId, refreshTrigger }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!tenantId) return;
    fetchUsers();
    // eslint-disable-next-line
  }, [tenantId, refreshTrigger]);

  const fetchUsers = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('No authentication token found');
      const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}conductor/tenant/${tenantId}/users`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!resp.ok) throw new Error('Failed to fetch users');
      const data = await resp.json();
      setRows(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { field: 'email', headerName: 'Email', flex: 1 },
    { field: 'first_name', headerName: 'First Name', flex: 1 },
    { field: 'last_name', headerName: 'Last Name', flex: 1 },
  ];

  return (
    <Box sx={{ width: '100%', height: 220, display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <DataGridPro
          rows={rows.map((row, idx) => ({ id: row.id || idx + 1, ...row }))}
          columns={columns}
          columnResizeMode="onEnd"
          resizable
          disableSelectionOnClick
          sx={{ ...harmonateDataGridSx, border: 'none', flex: 1 }}
          getRowId={(row) => row.id}
          rowHeight={35}
          components={{
            NoRowsOverlay: () => (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 100 }}>
                <Typography sx={{ color: ht.text, fontSize: '0.875rem' }}>No users found.</Typography>
              </Box>
            )
          }}
          pagination
          pageSize={100}
        />
      )}
    </Box>
  );
};

export default UserDrawer; 